import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a3e049d2&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a3e049d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e049d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3e049d2')) {
      api.createRecord('a3e049d2', component.options)
    } else {
      api.reload('a3e049d2', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a3e049d2&scoped=true&", function () {
      api.rerender('a3e049d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/teamMember.vue"
export default component.exports